import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-6" }
const _hoisted_2 = { class: "mb-12 mt-6 flex w-full flex-col items-center" }
const _hoisted_3 = { class: "text-xl font-medium" }
const _hoisted_4 = { class: "grid w-full grid-cols-2 gap-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": true,
    "is-full-screen-modal": false,
    "remove-outside-click": false,
    title: _ctx.$t('WorkOrders.MoveSensor'),
    onToggleModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.question), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_the_button, {
            text: _ctx.$t('General.Cancel'),
            variant: "outline",
            onExecuteMethod: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-modal')))
          }, null, 8, ["text"]),
          _createVNode(_component_the_button, {
            "is-loading": _ctx.isSubmitLoading,
            text: _ctx.$t('WorkOrders.MoveSensor'),
            variant: "default",
            onExecuteMethod: _ctx.moveSensor
          }, null, 8, ["is-loading", "text", "onExecuteMethod"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}